module.exports = __webpack_public_path__ + "img/function05.5461dd93.png";